import CallsRing from 'components/prospection/CallsRing';
import useText from 'hooks/useText';
import { goalProgress, statusLine } from 'pages/prospection/callListItems';

// A `{ key, count?, values }` descriptor of callListItems, as text.
const describe = ({ text, plural }, { key, count, values }) =>
  count === undefined ? text(key, values) : plural(key, count, values);

const BannerRing = ({ label, part, ringLabel }) => (
  <div className="flex flex-col items-center gap-1">
    {/* Green arcs stop at the goal; the centre still counts every call made. */}
    <CallsRing done={part.done} callbacks={0} total={part.goal} label={ringLabel} />
    <span className="font-title text-xs font-medium leading-4 text-body">
      {label}
    </span>
  </div>
);

/**
 * The goals banner of the call list: its title, the status line (green once
 * the goal is reached) and one ring per call type.
 */
const CallListBanner = ({ day, editing }) => {
  const texts = useText('prospection');
  const { text } = texts;
  const status = statusLine({ editing, day });
  const values = status.duration
    ? { ...status.values, duration: describe(texts, status.duration) }
    : status.values;
  const progress = goalProgress(day.counts);
  const ring = (type) => (
    <BannerRing
      label={text(`banner.${type}`)}
      part={progress[type]}
      ringLabel={text('banner.ring', {
        done: progress[type].done,
        goal: progress[type].goal,
      })}
    />
  );

  return (
    <div className="flex items-center gap-4 rounded-2xl bg-info-bg p-4">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <p className="font-title text-lg font-semibold leading-7 text-ink">
          {text('banner.title')}
        </p>
        <p
          data-testid="call-list-status"
          className={`font-title text-sm leading-5 ${status.tone === 'success' && !editing ? 'text-success' : 'text-body'}`}
        >
          {describe(texts, { ...status, values })}
        </p>
      </div>
      {ring('discovery')}
      {ring('followup')}
    </div>
  );
};

export default CallListBanner;
